export default __webpack_public_path__ + "static/media/phone-icon.2ceb470d.svg";